'use es6';

import { combineReducers } from 'redux';
import Immutable from 'immutable';
import * as RequestState from 'ecosystem-marketplace-core/constants/RequestState';
import * as ActionTypes from '../actions/ActionTypes';
const EMPTY_LIST = Immutable.List();

const requestState = (state = RequestState.UNINITIALIZED, {
  type
}) => {
  switch (type) {
    case ActionTypes.PARTNER_AWARDS_REQUESTED:
      return RequestState.PENDING;

    case ActionTypes.PARTNER_AWARDS_RECEIVED:
      return RequestState.SUCCEEDED;

    case ActionTypes.PARTNER_AWARDS_FAILED:
      return RequestState.FAILED;

    default:
      return state;
  }
};

const data = (state = EMPTY_LIST, {
  type,
  payload
}) => {
  switch (type) {
    case ActionTypes.PARTNER_AWARDS_RECEIVED:
      return payload.results;

    default:
      return state;
  }
};

export default combineReducers({
  requestState,
  data
});